import { C1Button } from 'c1ui'
import { CatalogProvider } from 'components/pages/requestcatalog/details/context/CatalogContext'
import { AddEntitlementsDrawer } from 'components/pages/requestcatalog/details/setup/add_entitlements/AddEntitlementsDrawer'
import { useDrawer } from 'hooks/useDrawer'
import { AppEntitlementRef } from 'pbts/c1/api/app/v1/app_refs'
import { useCallback } from 'react'

export type AddEntitlementsProps = {
    onSubmit: (entitlements: Array<AppEntitlementRef>, removedEntitlements: Array<AppEntitlementRef>, createRequests: boolean) => void
    buttonText: string
    buttonVariant?: 'contained' | 'outlined'
    requestCatalogId: string
    memberCount?: number
}

export const AddEntitlements = ({
    onSubmit,
    buttonText,
    buttonVariant = 'outlined',
    requestCatalogId,
    memberCount,
}: AddEntitlementsProps): React.ReactElement => {
    const [showDrawer, close] = useDrawer()
    const onClick = useCallback(
        () => showDrawer(
            <CatalogProvider value={{ requestCatalogId, memberCount }}>
                <AddEntitlementsDrawer onSubmit={onSubmit} close={close} />
            </CatalogProvider>,
            { variant: 'md' },
        ),
        [showDrawer, onSubmit, close, requestCatalogId, memberCount],
    )

    return <C1Button
        onClick={onClick}
        variant={buttonVariant}
    >
        {buttonText}
    </C1Button>
}
